export enum ENV {
  LOCAL,
  DEV,
  STAGE,
  PROD
}
